import { render } from "./AsociarAuditorOS.vue?vue&type=template&id=1805cbf8"
import script from "./AsociarAuditorOS.vue?vue&type=script&lang=js"
export * from "./AsociarAuditorOS.vue?vue&type=script&lang=js"

import "../assets/general.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__